// Live clipping timeline state: IN/OUT selection (stream seconds) and zoom.
export const ZOOM_PRESETS = Object.freeze([
  { key: 'all', label: 'Full', seconds: null },
  { key: '600', label: '10m', seconds: 600 },
  { key: '120', label: '2m', seconds: 120 },
  { key: '30', label: '30s', seconds: 30 },
])

export default {
  namespaced: true,
  state: {
    inTime: null,
    outTime: null,
    zoom: '600',
  },
  getters: {
    zoomSeconds: (state) => ZOOM_PRESETS.find((z) => z.key === state.zoom)?.seconds ?? null,
    selection: (state) => {
      const { inTime, outTime } = state
      if (!Number.isFinite(inTime) || !Number.isFinite(outTime) || outTime <= inTime) return null
      return { startTime: inTime, endTime: outTime, duration: outTime - inTime }
    },
  },
  mutations: {
    inTime: (state, t) => {
      state.inTime = Number.isFinite(t) ? t : null
      if (Number.isFinite(state.outTime) && state.outTime <= state.inTime) state.outTime = null
    },
    outTime: (state, t) => {
      state.outTime = Number.isFinite(t) ? t : null
      if (Number.isFinite(state.inTime) && state.inTime >= state.outTime) state.inTime = null
    },
    range: (state, { inTime, outTime }) => {
      state.inTime = inTime
      state.outTime = outTime
    },
    clear: (state) => {
      state.inTime = null
      state.outTime = null
    },
    zoom: (state, key) => {
      if (ZOOM_PRESETS.some((z) => z.key === key)) state.zoom = key
    },
  },
}
